var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { Icons } from '@appspotr/app';
import { IconContainer, IconGalleryContainer, IconGalleryTopBar, IconStyleButton, IconStyleRow, IconGalleryBottomBar, IconGalleryBottomText, IconGalleryIconSection, } from './styles';
import FontIconSingle from '../FontIcons/FontIcon';
import { IconSearch } from './iconSearch';
var GALLERY_PAGE_COUNT = 40;
var getPageCount = function (count) { return Math.floor(count / GALLERY_PAGE_COUNT); };
/** Standalone Icon Gallery for selecting and emitting selected icons */
export var IconGallery = function (_a) {
    var onSelect = _a.onSelect, icon = _a.icon, customIcons = _a.customIcons;
    var custom = customIcons === null || customIcons === void 0 ? void 0 : customIcons.map(function (i) { return ({
        prefix: 'custom',
        style: 'custom',
        id: i.id,
        iconName: i.name.slice(0, -4),
        extId: i.external_id,
    }); });
    Icons.custom = custom;
    var _b = useState((icon && icon.style) || 'light'), iconStyle = _b[0], setIconStyle = _b[1];
    var _c = useState({
        start: 0,
        end: GALLERY_PAGE_COUNT,
    }), galleryRange = _c[0], setGalleryRange = _c[1];
    var _d = useState(Icons[iconStyle]), iconList = _d[0], setIconList = _d[1];
    var _e = useState(iconList), filteredIcons = _e[0], setFilteredIcons = _e[1];
    var _f = useState(getPageCount(filteredIcons.length) + 1), totalPages = _f[0], setTotalPages = _f[1];
    var _g = useState(1), currentPage = _g[0], setCurrentPage = _g[1];
    // on search
    useEffect(function () {
        var newPageCount = getPageCount(filteredIcons.length) + 1;
        if (newPageCount !== totalPages) {
            setTotalPages(newPageCount);
            setCurrentPage(1);
            setGalleryRange({ start: 0, end: GALLERY_PAGE_COUNT });
        }
    }, [filteredIcons, totalPages]);
    var selectIcon = function (iconComponent) { return function () {
        onSelect(iconComponent);
    }; };
    var changeStyle = function (style) {
        setIconStyle(style);
        var newList = Icons[style];
        setIconList(newList);
    };
    var tabStart = function () {
        setGalleryRange({ start: 0, end: GALLERY_PAGE_COUNT });
        setCurrentPage(1);
    };
    var tabEnd = function () {
        var start = GALLERY_PAGE_COUNT * (totalPages - 1);
        var end = start + GALLERY_PAGE_COUNT;
        setGalleryRange({ start: start, end: end });
        setCurrentPage(getPageCount(start) + 1);
    };
    var tabLeft = function () {
        var start = galleryRange.start - GALLERY_PAGE_COUNT;
        if (start >= 0) {
            setGalleryRange({ start: start, end: galleryRange.start });
            setCurrentPage(getPageCount(galleryRange.start));
        }
    };
    var tabRight = function () {
        var end = galleryRange.end + GALLERY_PAGE_COUNT;
        var start = galleryRange.start + GALLERY_PAGE_COUNT;
        if (start <= filteredIcons.length - 1) {
            setGalleryRange({ start: galleryRange.end, end: end });
            setCurrentPage(getPageCount(end));
        }
    };
    var noCustomIconsText = "No custom icons found. Upload your own custom .svg files via the 'Media Explorer'";
    return (_jsxs(IconGalleryContainer, { children: [_jsxs(IconGalleryTopBar, { children: [_jsx(IconStyleRow, { children: Icons.styles &&
                            Icons.styles.map(function (i) { return (_jsx(IconStyleButton, __assign({ onClick: function () { return changeStyle(i.value); }, selected: i.value === iconStyle }, { children: _jsx(FontIconSingle, { size: "1x", icon: i.component }) }), i.value)); }) }), _jsx(IconSearch, { iconList: iconList, onSearch: setFilteredIcons })] }), _jsxs(IconGalleryIconSection, { children: [filteredIcons &&
                        filteredIcons.slice(galleryRange.start, galleryRange.end).map(function (i) { return (_jsx(IconContainer, __assign({ selectedIcon: (icon && icon.id === i.id) || null, onClick: selectIcon(i) }, { children: _jsx(FontIconSingle, { size: "1x", icon: i }) }), i.id)); }), iconStyle === 'custom' && (iconList === null || iconList === void 0 ? void 0 : iconList.length) === 0 && (_jsx("h5", __assign({ style: { fontWeight: 100, marginLeft: '5px' } }, { children: noCustomIconsText })))] }), _jsx(IconGalleryBottomBar, { children: _jsxs(IconStyleRow, { children: [_jsx(IconStyleButton, __assign({ disabled: currentPage === 1, onClick: tabStart }, { children: _jsx(FontIconSingle, { size: "1x", icon: Icons.angleDoubleLeft }) })), _jsx(IconStyleButton, __assign({ disabled: currentPage === 1, onClick: tabLeft }, { children: _jsx(FontIconSingle, { size: "1x", icon: Icons.angleLeft }) })), _jsx(IconGalleryBottomText, { children: "".concat(currentPage, "/").concat(totalPages) }), _jsx(IconStyleButton, __assign({ disabled: currentPage === totalPages, onClick: tabRight }, { children: _jsx(FontIconSingle, { size: "1x", icon: Icons.angleRight }) })), _jsx(IconStyleButton, __assign({ disabled: currentPage === totalPages, onClick: tabEnd }, { children: _jsx(FontIconSingle, { size: "1x", icon: Icons.angleDoubleRight }) }))] }) })] }));
};
